import { render, staticRenderFns } from "./AIConfigHelper.vue?vue&type=template&id=28507fd9&scoped=true"
import script from "./AIConfigHelper.vue?vue&type=script&lang=js"
export * from "./AIConfigHelper.vue?vue&type=script&lang=js"
import style0 from "./AIConfigHelper.vue?vue&type=style&index=0&id=28507fd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28507fd9",
  null
  
)

export default component.exports